import * as React from "react";

function SvgPickup(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M0.795072 8.15261H1.14567C1.14567 8.0717 1.11871 7.96382 1.11871 7.88291C1.11871 6.85807 1.90082 6.02202 2.89869 6.02202C3.86959 6.02202 4.65171 6.85807 4.65171 7.88291C4.65171 7.96382 4.65171 8.0717 4.62474 8.15261H8.88592C8.88592 8.0717 8.85895 7.96382 8.85895 7.88291C8.85895 6.85807 9.64106 6.02202 10.612 6.02202C11.5829 6.02202 12.392 6.85807 12.392 7.88291C12.392 7.90988 12.392 7.93685 12.392 7.96382C12.6077 7.77504 12.7426 7.47837 12.6616 7.15474C12.5807 6.77717 12.4729 6.42656 12.338 6.07596C12.2841 5.94111 12.1762 5.80626 12.0413 5.72536C11.475 5.34778 10.1805 5.18597 9.91076 5.18597C9.85682 5.18597 9.80288 5.18597 9.74894 5.159C8.40047 4.32294 8.45441 4.34991 8.31956 4.32294C7.05199 4.05325 5.78443 3.94537 4.40898 4.02628C4.13929 4.05325 3.92353 4.24203 3.89656 4.5387L3.78868 5.48263C3.24929 5.45566 1.44234 5.37475 0.606285 5.34778C0.147804 5.32081 -0.229769 5.67142 -0.310677 6.15687C-0.337647 6.29171 -0.229769 7.15474 0.120834 7.77504C0.33659 8.01776 0.552346 8.15261 0.795072 8.15261ZM8.26562 4.86233C8.31956 4.8893 8.53531 5.02415 9.23652 5.45566C9.18258 5.48263 9.31743 5.45566 6.89018 5.45566L6.80927 4.61961C7.32169 4.67355 7.80714 4.75445 8.26562 4.86233ZM4.51686 4.61961C4.51686 4.59264 4.51686 4.59264 4.51686 4.59264C5.11019 4.56567 5.70352 4.56567 6.26988 4.59264L6.35079 5.45566H4.40898L4.51686 4.61961Z"
          fill={fill ?? "black"}
        />
        <path
          d="M4.13929 7.88292C4.13929 7.15475 3.5999 6.56142 2.92566 6.56142C2.25143 6.56142 1.68507 7.15475 1.68507 7.88292C1.68507 8.6111 2.22446 9.20443 2.92566 9.20443C3.62687 9.20443 4.13929 8.6111 4.13929 7.88292Z"
          fill={fill ?? "black"}
        />
        <path
          d="M11.8795 7.88292C11.8795 7.15475 11.3401 6.56142 10.6389 6.56142C9.9647 6.56142 9.42531 7.15475 9.42531 7.88292C9.42531 8.6111 9.9647 9.20443 10.6389 9.20443C11.3401 9.20443 11.8795 8.6111 11.8795 7.88292Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPickup;
